import { render, staticRenderFns } from "./IframeCanvasWrapper.vue?vue&type=template&id=072a863d&"
import script from "./IframeCanvasWrapper.vue?vue&type=script&lang=ts&"
export * from "./IframeCanvasWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./IframeCanvasWrapper.vue?vue&type=style&index=0&id=072a863d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports